import { render, staticRenderFns } from "./IconLearningHours.vue?vue&type=template&id=abda4e38"
import script from "./IconLearningHours.vue?vue&type=script&lang=js"
export * from "./IconLearningHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports